import { render, staticRenderFns } from "./CSVAboutBox.vue?vue&type=template&id=2f5aa4ef"
import script from "./CSVAboutBox.vue?vue&type=script&lang=ts"
export * from "./CSVAboutBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports